// extracted by mini-css-extract-plugin
export default {"payment":"vs","title_row":"ws","border_bottom":"xs","promo_wrapper":"ys","payment_wrapper":"zs","label":"As","card_row":"Bs","cardcontain":"Cs","card_input":"Es","card_error":"Fs","card_label":"Gs","lock":"Hs","same_address":"Is","place_order_button":"Js","buttonwrap":"Ks","hide_form":"Ls","paypal_buttons":"Ms","review_button":"Ns","alt_payment":"Os"};
    if(module.hot) {
      // 1713211512451
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  